<template>
  <tr
    class="t-table-v2__row"
    :class="[{
      't-table-v2__row--highlighted': highlighted,
      't-table-v2__row--expanded': expanded
    }]"
    @click="$emit('rowClick', $event)"
  >
    <slot></slot>
  </tr>
</template>

<script>
export default {
  name: 't-table-v2-row',

  inject: ['$expanded'],

  props: {
    highlighted: Boolean,
  },

  computed: {
    expanded() {
      return this.$expanded();
    },
  },
};
</script>
